import { motion } from "framer-motion";
import { PreviewPanel } from "./PreviewPanel";
import ItemCard from "./ItemCard";
const ContentSection = ({
  id,
  title,
  items,
  activeId,
  setActiveId,
  theme,
  layout = "split",
  bgTexture,
}) => {
  const listVariants = {
    visible: { transition: { staggerChildren: 0.08 } },
    hidden: {},
  };
  const activeIndex = items.findIndex((item) => item.id === activeId);
  const progress =
    activeIndex > -1 ? ((activeIndex + 1) / items.length) * 100 : 0;
  const progressColor = theme === "blue" ? "bg-blue-500" : "bg-green-500";
  const cardGridClasses =
    layout === "split"
      ? ""
      : "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-12";

  return (
    <motion.div
      id={id}
      className={`relative py-2 md:py-4 px-4 sm:px-8 rounded-3xl ${
        layout === "split"
          ? "grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 items-start"
          : "w-full"
      }`}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.1 }}
    >
      {bgTexture && (
        <div
          className="absolute inset-0 opacity-5"
          style={{ backgroundImage: bgTexture }}
        ></div>
      )}
      {layout === "split" ? (
        <>
          <div className="lg:order-last">
            <PreviewPanel
              item={items.find((i) => i.id === activeId)}
              theme={theme}
              layout={layout}
            />
          </div>
          <div className="lg:order-first">
            <motion.h3
              variants={{
                hidden: { opacity: 0, y: -20 },
                visible: { opacity: 1, y: 0 },
              }}
              className="text-3xl sm:text-4xl font-bold text-slate-700 pb-3 mb-2"
            >
              {title}
            </motion.h3>
            <div className="w-full bg-gray-200 rounded-full h-1.5 mb-4">
              <motion.div
                className={`h-1.5 rounded-full ${progressColor}`}
                style={{ width: "0%" }}
                animate={{ width: `${progress}%` }}
                transition={{ duration: 0.5, ease: "easeInOut" }}
              />
            </div>
            <motion.ul
              role="list"
              aria-label={title}
              className="space-y-4"
              variants={listVariants}
            >
              {items.map((item) => (
                <ItemCard
                  key={item.id}
                  item={item}
                  isActive={item.id === activeId}
                  onClick={setActiveId}
                  theme={theme}
                />
              ))}
            </motion.ul>
          </div>
        </>
      ) : (
        <>
          <motion.h3
            variants={{
              hidden: { opacity: 0, y: -20 },
              visible: { opacity: 1, y: 0 },
            }}
            className="py-4 text-3xl sm:text-4xl font-bold text-slate-700 text-left"
          >
            {title}
          </motion.h3>
          <PreviewPanel
            item={items.find((i) => i.id === activeId)}
            theme={theme}
            layout={layout}
          />
          <motion.ul
            role="list"
            aria-label={title}
            className={cardGridClasses}
            variants={listVariants}
          >
            {items.map((item) => (
              <ItemCard
                key={item.id}
                item={item}
                isActive={item.id === activeId}
                onClick={setActiveId}
                theme={theme}
              />
            ))}
          </motion.ul>
        </>
      )}
    </motion.div>
  );
};

export default ContentSection;
